<coreui-modal panelCssClass="pick-list" modalWidth="60" modalHeight="auto" #pickListModal>
  <ng-template #titleTemplate>View All Values</ng-template>
  <ng-template #titleCloseButtonTemplate>
    <button type="button" aria-label="Close" (click)="pickListModal.hide()" coreUIButton="icon-large">
      <i coreUIIcon="close"></i>
    </button>
  </ng-template>
  <ng-template #contentTemplate>
    <div class="pick-list-content">
      <div class="pick-list-description">
        <div class="text-style-3">There are a total of <span
          class="text-style-2">{{ pickListResponse?.values?.length }}</span> values for
        </div>
        <div class="attribute-name text-style-5">{{ pickListResponse?.name }}</div>
      </div>
      <div class="text-style-3"> Select one or more values below, then choose <span
        class="text-style-2"> Add to Chat </span> to automatically add them to your audience prompt, it includes the
        full attribute and selected values in a format ready for building your audience criteria.
      </div>
    </div>
    <form [formGroup]="pickListFormGroup">
      <div class="search-table">
        <coreui-table-search placeholder="Search values" formControlName="search"></coreui-table-search>
        <coreui-table>
          <colgroup>
            <col width="10%" />
            <col />
          </colgroup>
          <thead coreUITableSort>
            <tr coreUITableHeaderRow>
              <th coreUITableCheckboxColumn>
                <label>
                  <input type="checkbox" coreUICheckbox [indeterminate]="headerCheckboxIndeterminate"
                         formControlName="headerCheckbox" />
                </label>
              </th>
              <th>
                <coreui-table-header-column (sort)="sort($event, 'id')">Value</coreui-table-header-column>
              </th>
            </tr>
          </thead>
          <tbody formArrayName="rows" coreUICheckboxMultipleSelection (multipleSelected)="onMultipleSelected($event)">
            <tr *ngFor="let pickListValue of filteredPickListValues | orderBy:sortOption:sortDirection index as i" coreUITableRow>
              <td [attr.aria-label]="'Select ' + pickListValue.id + ' row'" coreUITableCheckboxColumn>
                <label>
                  <input type="checkbox" coreUICheckbox [formControlName]="i" />
                </label>
              </td>
              <td>{{ pickListValue.id }}</td>
            </tr>
            <tr coreUITableRow [disableHover]="true" *ngIf="!filteredPickListValues.length && !showLoader">
              <td colspan="2">
                <coreui-graphic-message label="No Values Found" graphic="noResults">
                  Sorry, we did not find any values for your search.
                </coreui-graphic-message>
              </td>
            </tr>
            <tr coreUITableRow *ngIf="showLoader">
              <td>
                <coreui-loading-table-column></coreui-loading-table-column>
              </td>
              <td>
                <coreui-loading-table-column></coreui-loading-table-column>
              </td>
            </tr>
          </tbody>
        </coreui-table>
      </div>
    </form>
  </ng-template>
  <ng-template #buttonsTemplate>
    <button type="button" coreUIButton="text-primary" (click)="pickListModal.hide()"> Cancel</button>
    <button type="button" coreUIButton [disabled]="!isPickListValueSelected" (click)="addToChat()" withIcon="left">
      <i coreUIIcon="comment"></i>Add to Chat
    </button>
  </ng-template>
</coreui-modal>

<coreui-loading-indicator label="Loading..."></coreui-loading-indicator>

<coreui-notification notificationStyle="error" #pickListError>
  There is an error while fetching the picklist.
</coreui-notification>
